import {
  type LogEntry,
  LogLevel,
  type StandardLogger,
  type StaticLogData,
  type StrictStaticLogData,
  type UnknownLogDataProvider,
} from './types';

export abstract class StandardLoggerBase implements StandardLogger {
  abstract log(e: LogEntry): void;

  fatal(message: string, data?: UnknownLogDataProvider, error?: unknown): void {
    this.log({
      level: LogLevel.Fatal,
      message,
      error,
      data,
    });
  }

  error(message: string, data?: UnknownLogDataProvider, error?: unknown): void {
    this.log({
      level: LogLevel.Error,
      message,
      error,
      data,
    });
  }

  warn(message: string, data?: StaticLogData, error?: unknown): void {
    this.log({
      level: LogLevel.Warn,
      message,
      error,
      data,
    });
  }

  info(message: string, data?: StrictStaticLogData): void {
    this.log({
      level: LogLevel.Info,
      message,
      data,
    });
  }

  debug(message: string, data?: StaticLogData): void {
    this.log({
      level: LogLevel.Debug,
      message,
      data,
    });
  }

  trace(data: UnknownLogDataProvider): void {
    this.log({
      level: LogLevel.Trace,
      message: '>>>',
      data,
    });
  }
}
